import _map from 'lodash/map';
import _reduce from 'lodash/reduce';

export default {
	computed: {
		itemCount: function(){
			return _reduce(_map(this.cart, (item) => item.quantity), (item, total) => total += item);
		}
	}
}